import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import AdjustInventoryDialog from '../transferProduct/AdjustInventoryDialog';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import { showError } from 'actions/CommonActions';
import {
    getCategoryTree, getInventoryAdjust, getProductTypes, getWarehouses, clearSelectAdjustmentProduct, inventoryAdjustRoundPrices,
    setSelectAdjustmentProduct, getPriceMatrices, saveInventoryAdjust, syncProductsToLeafly, syncProductsToWeedmaps, getProductLocations,
    getProductByBarcode, clearProductTypeList, clearPriceMatrix, bulkUpdateMemberPrice
} from 'actions/EntityActions';
import { formInput, clearFormInput, clearInventoryAdjust } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import { inventoryAdjustCrumb } from 'utils/breadcrumbInfo';
import Header from './Header';
import { mapInventoryAdjustList } from 'utils/mappers';
import DialogConfirm from 'screens/components/basic/DialogConfirm';
import './styles/InventoryAdjust.scss';
import BarcodeReader from 'library/readBarcode';
import BulkUpdateMemberPriceDialog from './BulkUpdateMemberPriceDialog';
import CategoryUpdateMemberPriceDialog from './CategoryUpdateMemberPriceDialog';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

const pageName = "inventoryAdjust";

class InventoryAdjust extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 10,
            value: 'Active',
            status: 'Active',
            orderBy: "DESC",
            sortBy: "",
            openAdjust: false,
            confirmRoundDialog: false,
            confirmBulkUpdateMemberPriceDialog: false,
            confirmCategoryUpdateMemberPriceDialog: false,
            roundProduct: null
        };
        this.closeDialogAdjustment = this.closeDialogAdjustment.bind(this);
        this.adjustProduct = this.adjustProduct.bind(this);
        this.saveChanges = this.saveChanges.bind(this);

        this.barcodeReader = new BarcodeReader();
    }

    componentWillMount() {
        this.props.formInput(3 * (this.props.branchId) - 1, 'inventoryAdjustWarehouse');
    }

    componentWillReceiveProps(newProps) {
        if (this.props.refreshInventoryAdjust !== newProps.refreshInventoryAdjust) {
            this.getInventoryAdjust();
        }

        if (this.props.inventoryAdjustBranch && newProps.inventoryAdjustBranch && newProps.inventoryAdjustBranch !== this.props.inventoryAdjustBranch) {
            this.props.clearInventoryAdjust(pageName);
        }

        if (newProps.clearInventoryAdjustSuccess && newProps.clearInventoryAdjustSuccess !== this.props.clearInventoryAdjustSuccess && newProps.inventoryAdjustBranch) {
            this.switchBranchInventoryAdjust(parseInt(newProps.inventoryAdjustBranch));
        }

        if (newProps.roundPricesSuccess && newProps.roundPricesSuccess != this.props.roundPricesSuccess) {
            this.getInventoryAdjust();
        }

        if (newProps.bulkUpdateMemberPriceSuccess && newProps.bulkUpdateMemberPriceSuccess !== this.props.bulkUpdateMemberPriceSuccess) {
            this.getInventoryAdjust();
        }

        if (this.props.scannedTime !== newProps.scannedTime && newProps.scannedTime != null && newProps.scannedTime != undefined) {
            this.getInventoryAdjust(newProps.productScan.name);
        }

        if (newProps.barcodeNotFound && newProps.barcodeNotFound != this.props.barcodeNotFound) {
            this.props.showError("Product was not found. Check if the product is available.");
        }
    }

    componentDidMount() {
        this.props.getWarehouses(this.props.branchId);
        this.props.getProductTypes();
        this.getInventoryAdjust();
        this.props.getProductLocations(this.props.branchId);
        this.props.formInput(true, 'inventoryAdjustShowAdvancedOptions');
        this.props.formInput(this.props.branchId.toString(), 'inventoryAdjustBranch');
        window.addEventListener("keypress", this.barcodeListener);
        if (this.props.isMedical) {
            this.props.getPriceMatrices();
        }
    }

    componentWillUnmount() {
        this.clearFilters();
        this.props.clearInventoryAdjust(pageName);
        this.props.clearProductTypeList();
        this.props.clearPriceMatrix();
        this.props.clearFormInput('inventoryAdjustBranch');
        this.props.clearFormInput('clearInventoryAdjustSuccess');
        window.removeEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode)
        }
    }

    getProductByBarcode = (barcode) => {
        this.props.getProductByBarcode(barcode, this.props.branchId);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getInventoryAdjust);
    }

    clearFilters = () => {
        this.props.clearFormInput('inventoryAdjustCategoryFilter');
        this.props.clearFormInput('inventoryAdjustProductIdFilter');
        this.props.clearFormInput('inventoryAdjustNameFilter');
        this.props.clearFormInput('inventoryAdjustSKUFilter');
        this.props.clearFormInput('inventoryAdjustPOFilter');
        this.props.clearFormInput('inventoryAdjustDisplayNameFilter');
        this.props.clearFormInput('inventoryAdjustStatus');
        this.props.clearFormInput('inventoryAdjustType');
        this.props.clearFormInput('inventoryAdjustWarehouse');
        this.props.clearFormInput('inventoryAdjustWeight');
        this.props.clearFormInput('inventoryAdjustSpeciesFilter');
        this.props.clearFormInput('inventoryAdjustShowOnlyInStock');
        this.props.clearFormInput('inventoryAdjustUniversalProductCode');
    }

    cleanSearch = () => {
        this.clearFilters();
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "",
                orderBy: "DESC"
            };
        }, () => this.getInventoryAdjust());
    }

    getInventoryAdjust = (productName) => {
        let branchIdToUse = this.props.inventoryAdjustBranch ? parseInt(this.props.inventoryAdjustBranch) : this.props.branchId;
        const model = {
            branchId: branchIdToUse,
            productId: this.props.productId || 0,
            warehouseId: this.props.warehouseType == null || this.props.warehouseType == undefined ? 3 * (branchIdToUse) - 1 : this.props.warehouseType,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            productName: productName || this.props.productName || "",
            productSKU: this.props.productSKU || "",
            poNumber: this.props.poNumber || 0,
            displayName: this.props.displayName || "",
            categoryId: this.props.categoryId > 0 ? parseInt(this.props.categoryId) : null,
            status: this.props.productStatus ? this.props.productStatus : "None",
            typeId: this.props.productType > 0 ? this.props.productType : null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            weight: this.props.weight || 0,
            weightStatus: this.props.weightStatus || 0,
            imageStatus: this.props.image ? this.props.image : 0,
            digitalSignageEnabled: this.props.digitalSignageEnabled ? this.props.digitalSignageEnabled : 0,
            webmenuEnabled: this.props.webmenuEnabled ? this.props.webmenuEnabled : 0,
            location: this.props.location === "All" || !this.props.location ? "" : this.props.location,
            species: this.props.species || 0,
            showOnlyInStock: this.props.inventoryAdjustShowOnlyInStock,
            universalProductCode: this.props.universalProductCode || ""
        };
        this.props.getInventoryAdjust(model);
    }

    switchBranchInventoryAdjust = (newBranchId) => {
        this.props.formInput(3 * (newBranchId) - 1, 'inventoryAdjustWarehouse');
        this.props.getWarehouses(newBranchId);
        this.props.getProductLocations(newBranchId);
        const model = {
            branchId: newBranchId,
            productId: this.props.productId || 0,
            warehouseId: 3 * (newBranchId) - 1,
            page: 1,
            itemsPerPage: this.state.itemsPerPage,
            productName: this.props.productName || "",
            productSKU: this.props.productSKU || "",
            poNumber: this.props.poNumber || 0,
            displayName: this.props.displayName || "",
            categoryId: this.props.categoryId > 0 ? parseInt(this.props.categoryId) : null,
            status: this.props.productStatus ? this.props.productStatus : "None",
            typeId: this.props.productType > 0 ? this.props.productType : null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            weight: this.props.weight || 0,
            weightStatus: this.props.weightStatus || 0,
            imageStatus: this.props.image ? this.props.image : 0,
            digitalSignageEnabled: this.props.digitalSignageEnabled ? this.props.digitalSignageEnabled : 0,
            webmenuEnabled: this.props.webmenuEnabled ? this.props.webmenuEnabled : 0,
            location: this.props.location === "All" || !this.props.location ? "" : this.props.location,
            species: this.props.species || 0,
            showOnlyInStock: this.props.inventoryAdjustShowOnlyInStock,
            universalProductCode: this.props.universalProductCode || ""
        };
        this.props.getInventoryAdjust(model);
    }

    changePage = e => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e,
                confirmRoundDialog: false
            };
        }, this.getInventoryAdjust);
    }

    adjustProduct = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: true
            }
        }, () => this.props.setSelectAdjustmentProduct(product));
    }

    confirmRound = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                roundProduct: product
            };
        }, () => this.roundPrice());
    }

    openRoundConfirmDialog = () => {
        this.setState({ confirmRoundDialog: true });
    }

    openBulkUpdateMemberPriceDialog = () => {
        this.props.formInput(this.props.applicationSetting.memberDiscountPercentage.toFixed(2), 'BulkUpdateMemberPriceDialogmemberDiscountPercentage');
        this.setState({ confirmBulkUpdateMemberPriceDialog: true, confirmRoundDialog: false });
    }

    openCategoryUpdateMemberPriceDialog = () => {
        this.props.getCategoryTree();
        this.setState({ confirmCategoryUpdateMemberPriceDialog: true, confirmRoundDialog: false });
    }

    roundPrice = () => {
        let id = this.state.roundProduct.productId;

        let price = this.props.form[`inventoryAdjust_salePrice_` + id];
        let memberPrice = this.props.form[`inventoryAdjust_memberPrice_` + id];

        this.props.formInput(this.runRoundPrice(price), `inventoryAdjust_salePrice_` + id);
        this.props.formInput(this.runRoundPrice(memberPrice), `inventoryAdjust_memberPrice_` + id);
    }

    runRoundPrice = (price) => {
        if (price <= 0.24) price = 0.49;
        else {
            let dec = price - Math.floor(price);
            if (dec >= 0.24 && dec <= 0.74) price = Math.floor(price) + 0.49;
            else if (dec < 0.24) price = Math.floor(price) - 0.01;
            else price = Math.floor(price) + 0.99;
        }

        return price;
    }

    roundCancel = () => {
        this.setState({ confirmRound: false, roundProduct: null });
    }

    bulkUpdateMemberPriceCancel = () => {
        this.setState({ confirmBulkUpdateMemberPriceDialog: false, confirmRoundDialog: false });
    }

    categoryUpdateMemberPriceCancel = () => {
        this.setState({ confirmCategoryUpdateMemberPriceDialog: false });
    }

    closeDialogAdjustment = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: false
            }
        }, () => this.props.clearSelectAdjustmentProduct());
    }
    saveChanges = () => {
        this.setState({ confirmRoundDialog: false }); //if i dont add this, the confirm dialog opens at save
        const warehouseId = this.props.inventoryAdjust ? this.props.inventoryAdjust[0].warehouseId : 0;
        let branchIdToUse = this.props.inventoryAdjustBranch ? parseInt(this.props.inventoryAdjustBranch) : this.props.branchId;
        let inventoryAdjustProducts = [];
        this.props.inventoryAdjust.map(item => {
            let inventoryAdjustProduct = {};
            inventoryAdjustProduct[`productId`] = item.productId;
            inventoryAdjustProduct[`actualQuantity`] = this.props.form[`inventoryAdjust_actualQuantity_` + item.productId];
            inventoryAdjustProduct[`displayName`] = this.props.form[`inventoryAdjust_displayName_` + item.productId];
            inventoryAdjustProduct[`showDS`] = this.props.form[`inventoryAdjust_showDS_` + item.productId];
            inventoryAdjustProduct[`isDailySpecial`] = this.props.form[`inventoryAdjust_isDailySpecial_` + item.productId];
            inventoryAdjustProduct[`webMenuDisplayed`] = this.props.form[`inventoryAdjust_webMenuDisplayed_` + item.productId];
            inventoryAdjustProduct[`priceMatrixId`] = this.props.form[`inventoryAdjust_priceMatrixId_` + item.productId];
            inventoryAdjustProduct[`salePrice`] = this.props.form[`inventoryAdjust_salePrice_` + item.productId];
            inventoryAdjustProduct[`memberPrice`] = this.props.form[`inventoryAdjust_memberPrice_` + item.productId];
            inventoryAdjustProduct[`THCLevel`] = this.props.form[`inventoryAdjust_THCLevel_` + item.productId];
            inventoryAdjustProduct[`CBDLevel`] = this.props.form[`inventoryAdjust_CBDLevel_` + item.productId];
            inventoryAdjustProduct[`location`] = this.props.form[`inventoryAdjust_location_` + item.productId];
            inventoryAdjustProduct[`restockCap`] = this.props.form[`inventoryAdjust_restockCap_` + item.productId];
            inventoryAdjustProduct[`showSoldOut`] = this.props.form[`inventoryAdjust_showSoldOut_` + item.productId];
            inventoryAdjustProduct[`LotNumber`] = this.props.form[`inventoryAdjust_LotNumber_` + item.productId];
            inventoryAdjustProduct[`weightPerUnit`] = this.props.form[`inventoryAdjust_weightPerUnit_` + item.productId];
            inventoryAdjustProduct[`THC_MAX`] = this.props.form[`inventoryAdjust_thC_MAX_` + item.productId];
            inventoryAdjustProduct[`THC_MIN`] = this.props.form[`inventoryAdjust_thC_MIN_` + item.productId];
            inventoryAdjustProduct[`CBD_MAX`] = this.props.form[`inventoryAdjust_cbD_MAX_` + item.productId];
            inventoryAdjustProduct[`CBD_MIN`] = this.props.form[`inventoryAdjust_cbD_MIN_` + item.productId];
            inventoryAdjustProduct[`potencyShow`] = this.props.form[`inventoryAdjust_showPotency_` + item.productId];
            let realLotnumber;
            if (inventoryAdjustProduct[`LotNumber`] == 'None') {
                realLotnumber = '';
            } else {
                realLotnumber = inventoryAdjustProduct[`LotNumber`];
            }

            if (inventoryAdjustProduct[`actualQuantity`] != item.actualQty
                || inventoryAdjustProduct[`displayName`] != item.displayName
                || inventoryAdjustProduct[`showDS`] != item.digitalSignageDisplayed
                || inventoryAdjustProduct[`priceMatrixId`] != item.priceMatrixId
                || inventoryAdjustProduct[`salePrice`] != (item.salePrice || 0).toFixed(2)
                || inventoryAdjustProduct[`memberPrice`] != (item.memberPrice || 0).toFixed(2)
                //needs fix here
                || (item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber) && item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber).thC_Level != inventoryAdjustProduct[`THCLevel`])
                || (item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber) && item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber).cbD_Level != inventoryAdjustProduct[`CBDLevel`])
                || inventoryAdjustProduct[`location`] != item.location
                || inventoryAdjustProduct[`restockCap`] != item.restockCap
                || inventoryAdjustProduct[`showSoldOut`] != item.showSoldOut
                || inventoryAdjustProduct[`isDailySpecial`] != item.isDailySpecial
                || inventoryAdjustProduct[`webMenuDisplayed`] != item.webMenuDisplayed
                || inventoryAdjustProduct[`weightPerUnit`] != item.weightPerUnit
                || inventoryAdjustProduct[`THC_MAX`] != item.thC_MAX
                || inventoryAdjustProduct[`THC_MIN`] != item.thC_MIN
                || inventoryAdjustProduct[`CBD_MAX`] != item.cbD_MAX
                || inventoryAdjustProduct[`CBD_MIN`] != item.cbD_MIN
                || (item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber) && inventoryAdjustProduct[`potencyShow`] != item.inventoryAdjustPackageDTO.find(x => x.packageReference == realLotnumber).potencyShow)) {
                inventoryAdjustProducts.push(inventoryAdjustProduct);
            }
        });
        let updateInventoryAdjustVM = { branchId: branchIdToUse, warehouseId, inventoryAdjustProducts };
        this.props.saveInventoryAdjust(updateInventoryAdjustVM);
    }

    syncToLeafly = () => {
        this.props.syncProductsToLeafly(this.props.branchId);
    }

    syncToWeedmaps = () => {
        this.props.syncProductsToWeedmaps(this.props.branchId);
    }

    roundAllPrices = () => {
        this.props.formInput(false, 'inventoryAdjustRoundPriceSuccess');
        this.props.inventoryAdjustRoundPrices({ branchId: this.props.branchId });
        this.setState({ confirmRoundDialog: false });
    }

    bulkUpdateMemberPrices = () => {
        this.props.bulkUpdateMemberPrice({ branchId: this.props.branchId, percentageDiscount: this.props.memberPercentageDiscount });
        this.setState({ confirmBulkUpdateMemberPriceDialog: false });
    }

    render() {
        const p = this.props;
        const s = this.state;
        let categories = [];
        categories.push({ text: "All", value: "0" });
        const cat = p.productTypes.length > 0 ? p.productTypes[0].categories : [];
        cat.map(item => {
            categories.push({
                text: item.name,
                value: item.id.toString()
            });
        });

        categories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });
        let priceMatrixList = [];
        p.priceMatrixList.map(item => {
            priceMatrixList.push({
                text: item.name,
                value: item.id
            })
        });
        let productLocations = [];
        productLocations.push({ text: "All", value: "0" });
        p.productLocations.map((item, index) => {
            productLocations.push({
                text: item,
                value: index + 1
            })
        });

        let inventoryAdjustColumns = [
            { key: "ProductName", label: "Product Name" },
            { key: "ProductInfo", label: "Product Info" },
            { key: "inStock", label: "Stock" },
            { key: "SalePrice", label: "Selling Price" },
            { key: "AvgPurchasePrice", label: "Purchase Price" },
            { key: "Profit", label: "Profit" }
        ];

        if (!p.isVape) inventoryAdjustColumns.push({ key: "Potency", label: "Potency" });

        if (p.applicationSetting) {
            if (p.applicationSetting.digitalSignageEnabled) {
                inventoryAdjustColumns.push({ key: "DisplayName", label: "Digital Signage" });
            }

            if (p.applicationSetting.hasWebMenu) {
                inventoryAdjustColumns.push({ key: "Ecommerce", label: "Ecommerce" });
            }
        }


        let simpleInventoryAdjustColumns = [
            { key: "ProductName", label: "Product Name" },
            { key: "inStock", label: "Stock" },
            { key: "SalePrice", label: "Selling Price" }
        ];

        let inventoryAdjustColumnsToShow = null;

        if (p.inventoryAdjustShowAdvancedOptions) {
            inventoryAdjustColumnsToShow = inventoryAdjustColumns;
        } else {
            inventoryAdjustColumnsToShow = simpleInventoryAdjustColumns;
        }

        return (
            <Grid headerContent={inventoryAdjustCrumb}>
                <PageHeaderWithButton title={`${LOOKUP.transferProduct.inventoryAdjust.label} ${p.inventoryAdjustBranchText ? p.inventoryAdjustBranchText : ""}`}>
                    {p.applicationSetting && p.applicationSetting.leaflyEnabled && (
                        <Button
                            type="RaisedButton"
                            mini={true}
                            label="Sync All Products to Leafly"
                            className="btnNewBrandPOS mb-2"
                            onTouchTap={this.syncToLeafly}
                        />

                    )}
                    {p.applicationSetting && p.applicationSetting.weedmapsEnable && (
                        <Button
                            type="RaisedButton"
                            mini={true}
                            label="Sync All Products to Weedmaps"
                            className="btnNewBrandPOS mb-2"
                            onTouchTap={this.syncToWeedmaps}
                        />
                    )}
                    <div className='d-flex justify-content-end' >
                        <Button
                            type="SaveButtonNoIcon"
                            mini={true}
                            id="buttonRoundAllProducts"
                            label={LOOKUP.patient.controls.roundPrices}
                            className="primary-color-bg btnNewBrandPOS marginTopMobile mb-2"
                            onTouchTap={this.openRoundConfirmDialog}
                            style={{
                                '&.MuiButtonBase-root': {
                                    display: 'block'
                                },
                            }}
                        />
                    </div>
                    <div className='d-flex justify-content-end' >

                        <Button
                            type="SaveButtonNoIcon"
                            mini={true}
                            id="buttonBulkMemberPriceUpdate"
                            label={"Bulk Member Price Update"}
                            className="primary-color-bg mb-2"
                            onTouchTap={this.openBulkUpdateMemberPriceDialog}
                            style={{
                                '&.MuiButtonBase-root': {
                                    display: 'block'
                                },
                            }}
                        />
                    </div>
                    <div className='d-flex justify-content-end' >

                        <Button
                            type="SaveButtonNoIcon"
                            mini={true}
                            id="buttonSetMemberPricesByCategory"
                            label={"Set Member Prices By Category"}
                            className="primary-color-bg"
                            onTouchTap={this.openCategoryUpdateMemberPriceDialog}
                            style={{
                                '&.MuiButtonBase-root': {
                                    display: 'block'
                                },
                            }}
                        />
                    </div>
                </PageHeaderWithButton>

                <CardSimple className="p-1">
                    <Header
                        pageName={pageName}
                        cleanSearch={this.cleanSearch}
                        search={this.search}
                        categories={categories}
                        locations={productLocations}
                        warehouses={p.warehouses}
                        saveChanges={this.saveChanges}
                        digitalSignageEnabled={p.applicationSetting && p.applicationSetting.digitalSignageEnabled}
                        branchOptions={p.branchOptions}
                        isVape={p.isVape}
                    />
                </CardSimple>
                <Button
                    type="SaveButton"
                    mini={true}
                    id="buttonSaveChanges"
                    label={LOOKUP.patient.controls.saveAllButton}
                    className="btnNewBrandPOS marginTopMobile vertical-space"
                    onTouchTap={this.saveChanges}
                />
                <CardSimple>
                    <GenericTable
                        compName="inventoryAdjustTable"
                        columns={inventoryAdjustColumnsToShow}
                        rows={mapInventoryAdjustList(p.inventoryAdjust, this.adjustProduct, this.confirmRound, priceMatrixList, p.form, p.canViewProductDetail, p.isVape)}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        stripedRows={true}
                    />
                    <Pagination
                        length={p.inventoryAdjustLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={this.changePage}
                        maxButtons={8}
                    />
                </CardSimple>

                <Button
                    name="saveButton"
                    label={LOOKUP.patient.controls.saveAllButton}
                    primary={true}
                    className="btnNewBrandPOS"
                    onTouchTap={this.saveChanges} />

                {this.state.openAdjust ? <AdjustInventoryDialog name="adjustmentInventoryDialog" onClose={this.closeDialogAdjustment} placeOfInventoryChange={"2"} /> : ''}
                <DialogConfirm title="Confirm Price Round"
                    message="Are you sure you want to round all product prices (only in stock)? After rounding they cannot be reverted. Rounding all product prices can take a long time"
                    isOpen={this.state.confirmRoundDialog}
                    onCancel={this.roundCancel}
                    onConfirm={this.roundAllPrices} />
                <CategoryUpdateMemberPriceDialog
                    isOpen={this.state.confirmCategoryUpdateMemberPriceDialog}
                    onCancel={this.categoryUpdateMemberPriceCancel}
                    onConfirm={this.categoryUpdateMemberPrices} />
                <BulkUpdateMemberPriceDialog title="Confirm Bulk Member Price Update"
                    message="Are you sure you want to update all member prices? Only in-stock items will be updated. Once confirmed, updates cannot be reverted. Updating all products may take up to 30 mins. Member Price discount is set in the Member Price Discount Setting."
                    isOpen={this.state.confirmBulkUpdateMemberPriceDialog}
                    onCancel={this.bulkUpdateMemberPriceCancel}
                    onConfirm={this.bulkUpdateMemberPrices} />
            </Grid>
        )
    }
}


function mapStateToProps(state) {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    });
    return {
        branchOptions: branchOptions,
        branchId: state.common.branchId,
        branchName: state.common.store.name,
        warehouses: state.entity.warehouses || [],
        categoryId: state.form["inventoryAdjustCategoryFilter"],
        productId: state.form["inventoryAdjustProductIdFilter"],
        productName: state.form["inventoryAdjustNameFilter"],
        productSKU: state.form["inventoryAdjustSKUFilter"],
        displayName: state.form["inventoryAdjustDisplayNameFilter"],
        productStatus: state.form["inventoryAdjustStatus"],
        productType: state.form["inventoryAdjustType"],
        warehouseType: state.form["inventoryAdjustWarehouse"] || null,
        poNumber: state.form["inventoryAdjustPOFilter"] || 0,
        weight: state.form["inventoryAdjustWeight"],
        weightStatus: state.form["inventoryAdjustHasWeight"],
        image: state.form["inventoryAdjustHasImage"],
        species: state.form["inventoryAdjustSpeciesFilter"],
        digitalSignageEnabled: state.form["inventoryAdjustDigitalSignageEnabled"],
        webmenuEnabled: state.form["inventoryAdjustWebmenuEnabled"],
        location: state.form["inventoryAdjustLocationText"],
        productTypes: state.entity.productTypesList,
        inventoryAdjust: state.entity.inventoryAdjust || [],
        inventoryAdjustLength: state.entity.inventoryAdjustLength || 0,
        priceMatrixList: state.entity.priceMatricesList || [],
        refreshInventoryAdjust: state.entity.refreshInventoryAdjust,
        form: state.form,
        applicationSetting: state.common.applicationSettings || null,
        canViewProductDetail: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewProductDetail")),
        productLocations: state.entity.productLocations || [],
        inventoryAdjustShowAdvancedOptions: state.form["inventoryAdjustShowAdvancedOptions"] || null,
        inventoryAdjustShowOnlyInStock: state.form["inventoryAdjustShowOnlyInStock"] || false,
        inventoryAdjustBranchText: state.form["inventoryAdjustBranchText"],
        inventoryAdjustBranch: state.form["inventoryAdjustBranch"],
        clearInventoryAdjustSuccess: state.form["clearInventoryAdjustSuccess"],
        roundPricesSuccess: state.form["inventoryAdjustRoundPriceSuccess"],
        bulkUpdateMemberPriceSuccess: state.form["bulkupdateMemberPriceSuccessTimeStamp"],
        productScan: state.entity.productDetail,
        scannedTime: state.entity.scannedTime,
        barcodeNotFound: state.entity.barcodeNotFound,
        isMedical: state.common.applicationSettings.isMedical,
        isVape: state.common.applicationSettings.isVape,
        memberPercentageDiscount: state.form["BulkUpdateMemberPriceDialogmemberDiscountPercentage"] || 0,
        universalProductCode: state.form["inventoryAdjustUniversalProductCode"] || ""
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getCategoryTree: () => dispatch(getCategoryTree(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        syncProductsToLeafly: (branchId) => dispatch(syncProductsToLeafly(branchId)),
        syncProductsToWeedmaps: (branchId) => dispatch(syncProductsToWeedmaps(branchId)),
        getWarehouses: (branchId) => dispatch(getWarehouses(branchId)),
        getInventoryAdjust: (model) => dispatch(getInventoryAdjust(model)),
        clearSelectAdjustmentProduct: () => dispatch(clearSelectAdjustmentProduct()),
        getProductTypes: () => dispatch(getProductTypes()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        setSelectAdjustmentProduct: (product) => dispatch(setSelectAdjustmentProduct(product)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        saveInventoryAdjust: (model) => dispatch(saveInventoryAdjust(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductLocations: (branchId) => dispatch(getProductLocations(branchId)),
        clearInventoryAdjust: (compName) => dispatch(clearInventoryAdjust(compName)),
        inventoryAdjustRoundPrices: (model) => dispatch(inventoryAdjustRoundPrices(model)),
        bulkUpdateMemberPrice: (model) => dispatch(bulkUpdateMemberPrice(model)),
        getProductByBarcode: (barcode, branchId) => dispatch(getProductByBarcode(barcode, branchId)),
        showError: (message) => dispatch(showError(message)),
        clearProductTypeList: () => dispatch(clearProductTypeList()),
        clearPriceMatrix: () => dispatch(clearPriceMatrix())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryAdjust);